import {TDashboard} from "../store/reducers/DashboardSlice";
import BigNumber from "bignumber.js";

export const utils = {
    hexAddress(address: string): string {
        return `${address.substr(0, 5)}...${address.substr(-4)}`;
    },
    BNtoNum(value, decimal = 18) {
        return new BigNumber(value).shiftedBy(-decimal).toNumber();
    },
      
    NumToBN(value, decimal = 18){
        return new BigNumber(value).shiftedBy(decimal);
    },
    computeAllStackedTokens(dashboard: TDashboard): number {
        if (!dashboard) return 0;
        return dashboard.investedFunds! + dashboard.earned!;
    }

};
